import type { TaskEither } from 'fp-ts/lib/TaskEither';
import { fetchTE } from 'utils/request';

export const listUserOrgInvitationsTE = <E = CF.API.ApiError>(
  { userId, params = '' }: { userId: string; params?: string },
  onRejected?: (e: CF.API.ApiError) => E,
): TaskEither<E, CF.API.Organizations.ListInvitedOrgMembersResponse> =>
  fetchTE<CF.API.Organizations.ListInvitedOrgMembersResponse, E>(
    {
      path: `/api/_api/v2/users/${userId}/organization_invitations${params ? `?${params}` : ''}`,
    },
    onRejected,
  );
